import { IClipboardItem } from "../../domain/system";

export class ClipboardItem<T> implements IClipboardItem<T> {
  constructor(public sequenceNo: number, public value: T) {
  }
}
